module.exports = __webpack_public_path__ + "static/media/todo.8e00b322.png";